
import React from 'react';
import Layout from '@/components/layout/Layout';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import FinanceApprovalsRejected from '@/components/finance/FinanceApprovalsRejected';

const FinanceApprovalsRejectedPage = () => {
  return (
    <Layout>
      <div className="w-full max-w-full py-8">
        <h1 className="text-3xl font-bold mb-8">Rejected Procurements</h1>
        
        <Card className="w-full">
          <CardHeader>
            <CardTitle>Finance Rejected Procurements</CardTitle>
          </CardHeader>
          <CardContent>
            <FinanceApprovalsRejected />
          </CardContent>
        </Card>
      </div>
    </Layout>
  );
};

export default FinanceApprovalsRejectedPage;
